module.exports = __webpack_public_path__ + "img/0-80.aab5bad5.jpg";